"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KEY = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _vegaEmbed = require("vega-embed");

var _vegaEmbed2 = _interopRequireDefault(_vegaEmbed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Vega = function (_Component) {
  _inherits(Vega, _Component);

  function Vega(props) {
    _classCallCheck(this, Vega);

    var _this = _possibleConstructorReturn(this, (Vega.__proto__ || Object.getPrototypeOf(Vega)).call(this, props));

    _this.state = {
      spec: props.spec,
      parsedSpec: JSON.parse(props.spec)
    };
    return _this;
  }

  _createClass(Vega, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.rerender();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.rerender();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var spec = _ref.spec;

      if (this.state.spec !== spec) {
        this.setState({
          spec: spec,
          parsedSpec: JSON.parse(spec)
        });
      }
    }
  }, {
    key: "rerender",
    value: function rerender() {
      (0, _vegaEmbed2.default)(this.node, JSON.parse(this.state.spec), {
        actions: false,
        padding: 0
      }).catch(console.error);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement("div", {
        ref: function ref(node) {
          return _this2.node = node;
        }
      });
    }
  }]);

  return Vega;
}(_react.Component);

Vega.propTypes = {
  spec: _propTypes2.default.string.isRequired
};

var KEY = exports.KEY = "vega";

exports.default = Vega;


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-remark-vega/dist/client.js
// module id = 157
// module chunks = 35783957827783 107818501498521